import SiteLayout from "../components/site/SiteLayout";

function Donate() {
  const handleSubmit = (event) => event.preventDefault();

  return (
    <SiteLayout>
      <section className="page-hero">
        <div className="container">
          <h1>Donate</h1>
          <p>
            Your support funds education, healthcare, and livelihood programs that deliver lasting
            change.
          </p>
        </div>
      </section>
      <section className="section">
        <div className="container split-grid">
          <div className="card">
            <h3>Choose your impact</h3>
            <p>
              Every donation is allocated transparently to the program you care about the most.
            </p>
            <div className="card-grid">
              <div className="card" style={{ "--i": 0 }}>
                <strong>INR 1,500</strong>
                <p>Supplies one child with school materials for a year.</p>
              </div>
              <div className="card" style={{ "--i": 1 }}>
                <strong>INR 3,000</strong>
                <p>Funds a mobile health visit for a rural community.</p>
              </div>
              <div className="card" style={{ "--i": 2 }}>
                <strong>INR 5,000</strong>
                <p>Supports skill training for two women entrepreneurs.</p>
              </div>
            </div>
          </div>
          <form className="form-card" onSubmit={handleSubmit}>
            <h3>Donation form</h3>
            <div className="form-grid">
              <label>
                Donation Type
                <select name="donationType" defaultValue="one-time">
                  <option value="one-time">One-time</option>
                  <option value="monthly">Monthly</option>
                </select>
              </label>
              <label>
                Amount (INR)
                <input type="number" name="amount" min="500" defaultValue="1500" required />
              </label>
              <label>
                Full Name
                <input type="text" name="name" placeholder="Rohan Kapoor" required />
              </label>
              <label>
                Email Address
                <input type="email" name="email" placeholder="rohan@email.com" required />
              </label>
              <label>
                Phone Number
                <input type="tel" name="phone" placeholder="+91 98 7000 1100" required />
              </label>
              <button className="btn btn-secondary" type="submit">
                Continue to Payment
              </button>
            </div>
          </form>
        </div>
      </section>
    </SiteLayout>
  );
}

export default Donate;
